export enum ComplianceStatusEnum {
  PENDING = 'pending',
  COMPLETE = 'complete',
  ON_HOLD = 'on_hold',
  CASH = 'cash',
  REFUND = 'refund'
}
